import openSocket from "socket.io-client";
import { SOCKET_URL, USER_UPDATE, USER_BALANCE_UPDATE, GATWAY_REPLY } from "constant/apiService";
import { cookie } from "utils/cookie";
import { AUTH_TOKEN, AUTH_USER_BALANCE, AUTH_USER_INFO } from "constant/constant";

export const socket = openSocket(SOCKET_URL, {
  secure: true,
  jsonp: false,
  path: "/socket.io",
  transports: ["websocket", "polling"],
  withCredentials: true,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
});

socket.on("connect", () => console.log("⚡ Sockets Connected ⚡"));
socket.on("disconnect", () => console.log("🔴 Sockets Disconnected 🔴"));
socket.on("connect_error", _ => console.error("❌ Socket connection error ❌", _));
class Socket {
  constructor({ state }) {
    this.io = null;
    this.state = state;
    this.startSocket();
  }

  startSocket() {
    socket.on(USER_UPDATE, user => {
      user = JSON.parse(user);
      console.log("⚡ User updated 👌");
      this.state.authStore.user = user;
      cookie.set(AUTH_USER_INFO, user);
    });

    socket.on(USER_BALANCE_UPDATE, data => {
      data = JSON.parse(data);
      console.log("⚡ Balance updated 👌");
      this.state.authStore.balanceObj = data;
      cookie.set(AUTH_USER_BALANCE, data);
    });

    socket.on(GATWAY_REPLY, messageObj => {
      messageObj = JSON.parse(messageObj);
      this.state.gatewayStore.newMessageEvent(messageObj);
      this.state.messageStore.newMessageEvent(messageObj);
      this.state.authStore.setuserNotificationList(messageObj);
      this.state.authStore.setnewUserNotification(true);
    });
  }
}

export default Socket;
